module.exports = __webpack_public_path__ + "img/ppro.81483c5a.svg";